import { useEffect, useCallback, useState } from 'react';

import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';

import "./style.css";

// ➜ Charge la lib Stripe côté client (clé publique)
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function StripeCheckout({ setModal, cart, customerInfo }) {
    const [sessionId, setSessionId] = useState(null);

    const fetchClientSecret = useCallback(async () => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/payements/create-checkout-session`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cart, customerInfo }),
        });
        const data = await res.json();

        if (res.status !== 200) {
            alert(data.message);
            return
        }
        setSessionId(data.sessionId);
        return data.clientSecret;

    }, [cart, customerInfo]);

    useEffect(() => {
        if (!sessionId) return;

        const poll = setInterval(async () => {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/payements/verify-session?session_id=${sessionId}`);
            if (!res.ok) return;

            const { status } = await res.json();

            if (status === 'paid') {
                clearInterval(poll);

                setTimeout(() => {
                    setModal('success');
                }, 1500);
            }
        }, 1000);

        return () => clearInterval(poll);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionId]);

    return (
        <div className="stripe_form">
            <div className="boxx">
                <div className="stripe_box">
                    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
                        <EmbeddedCheckout />
                    </EmbeddedCheckoutProvider>
                </div>
            </div>
        </div>
    );
}

export default StripeCheckout;